var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2132 8.7868C45.5871 3.1607 37.9565 0 30 0C22.0435 0 14.4129 3.1607 8.7868 8.7868C3.1607 14.4129 0 22.0435 0 30C0 37.9565 3.1607 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868ZM30 55.979C15.6754 55.979 4.02098 44.3248 4.02098 30C4.02098 15.6752 15.6752 4.02098 30 4.02098C44.3248 4.02098 55.979 15.6752 55.979 30C55.979 44.3248 44.3248 55.979 30 55.979Z",
    fill: "#76D914"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7639 34.4624C26.3734 34.8529 25.7402 34.8529 25.3497 34.4624L19.0767 28.1895C18.6861 27.7989 18.053 27.7989 17.6625 28.1895L16.7074 29.1446C16.3168 29.5351 16.3168 30.1683 16.7074 30.5588L25.3497 39.2011C25.7402 39.5916 26.3734 39.5916 26.7639 39.2011L42.8889 23.0762C43.2794 22.6857 43.2794 22.0525 42.8889 21.662L41.9337 20.7068C41.5432 20.3163 40.91 20.3163 40.5195 20.7068L26.7639 34.4624Z",
    fill: "#76D914"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmMark);
export default __webpack_public_path__ + "static/media/confirm-mark.45eb939154c5b9ea21fc4dfe4a22e8e4.svg";
export { ForwardRef as ReactComponent };